import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'loading-pua',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  /**
   * @ignore
   */
  constructor() {}
}
